import type { Provider } from "../types";
import { STATE_NAMES } from "../types";
import { ProviderBadge } from "./ProviderBadge";

interface StateSelectProps {
  provider: Provider;
  selectedState: string | null;
  onSelectState: (state: string) => void;
  onContinue: () => void;
}

export function StateSelect({ provider, selectedState, onSelectState, onContinue }: StateSelectProps) {
  return (
    <div>
      <div className="flex items-center gap-3">
        <ProviderBadge provider={provider} />
        <h1 className="text-base font-semibold text-gray-900">Log into {provider.name}</h1>
      </div>

      <div className="mt-5">
        <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
          State
        </label>
        <select
          id="state"
          value={selectedState || ""}
          onChange={(e) => onSelectState(e.target.value)}
          className="w-full border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:outline-none focus:border-gray-500"
        >
          <option value="" disabled>
            Select a state
          </option>
          {provider.states.map((code) => (
            <option key={code} value={code}>
              {STATE_NAMES[code] || code}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        onClick={onContinue}
        disabled={!selectedState}
        className="mt-6 w-full py-2.5 bg-gray-900 text-white text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-800"
      >
        Continue to login
      </button>
    </div>
  );
}
